import { hasAnyAuthority } from './has-any-authority';
/** Hide menu branches the user cannot access; drop empty parent sections. */
export function filterMenuByPermissions(items, userPermissions) {
    return items
        .map((item) => {
        if (item.items?.length) {
            const children = filterMenuByPermissions(item.items, userPermissions);
            if (children.length === 0) {
                return null;
            }
            return { ...item, items: children };
        }
        const required = item.authorities;
        if (required?.length && !hasAnyAuthority(userPermissions, required)) {
            return null;
        }
        return item;
    })
        .filter((item) => item !== null);
}
